import { createApiSaga } from '../../sagaGenerator';
import { apiDelete, apiGet, apiPatch } from '../../../middleware/api';
import {
  REFERENCE_DATA_BULK_EDIT_FAILURE,
  REFERENCE_DATA_BULK_EDIT_REQUEST,
  REFERENCE_DATA_BULK_EDIT_SUCCESS,
  REFERENCE_DATA_DELETE_REFERENCE_FAILURE,
  REFERENCE_DATA_DELETE_REFERENCE_REQUEST,
  REFERENCE_DATA_DELETE_REFERENCE_SUCCESS,
  REFERENCE_DATA_HAVE_FAILURE,
  REFERENCE_DATA_HAVE_REQUEST,
  REFERENCE_DATA_HAVE_SUCCESS,
  REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_FAILURE,
  REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_REQUEST,
  REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_SUCCESS,
  REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_FAILURE,
  REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_REQUEST,
  REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_SUCCESS,
  REFERENCE_EARTHQUAKE_DATA_REGION_FAILURE,
  REFERENCE_EARTHQUAKE_DATA_REGION_REQUEST,
  REFERENCE_EARTHQUAKE_DATA_REGION_SUCCESS,
  REFERENCE_RUNUP_DATA_CAUSE_FAILURE,
  REFERENCE_RUNUP_DATA_CAUSE_REQUEST,
  REFERENCE_RUNUP_DATA_CAUSE_SUCCESS,
  REFERENCE_RUNUP_DATA_MEASURE_TYPE_FAILURE,
  REFERENCE_RUNUP_DATA_MEASURE_TYPE_REQUEST,
  REFERENCE_RUNUP_DATA_MEASURE_TYPE_SUCCESS,
  REFERENCE_RUNUP_DATA_REGION_FAILURE,
  REFERENCE_RUNUP_DATA_REGION_REQUEST,
  REFERENCE_RUNUP_DATA_REGION_SUCCESS,
  REFERENCE_RUNUP_DATA_VALIDITY_FAILURE,
  REFERENCE_RUNUP_DATA_VALIDITY_REQUEST,
  REFERENCE_RUNUP_DATA_VALIDITY_SUCCESS,
  REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_FAILURE,
  REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_REQUEST,
  REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_SUCCESS,
  REFERENCE_TSUNAMI_EVENT_DATA_REGION_FAILURE,
  REFERENCE_TSUNAMI_EVENT_DATA_REGION_REQUEST,
  REFERENCE_TSUNAMI_EVENT_DATA_REGION_SUCCESS,
  REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE,
  REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST,
  REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS,
  REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_FAILURE,
  REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_REQUEST,
  REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS,
  REFERENCE_VOLCANO_EVENT_DATA_REGION_FAILURE,
  REFERENCE_VOLCANO_EVENT_DATA_REGION_REQUEST,
  REFERENCE_VOLCANO_EVENT_DATA_REGION_SUCCESS,
  REFERENCE_VOLCANO_LOCATION_REGION_FAILURE,
  REFERENCE_VOLCANO_LOCATION_REGION_REQUEST,
  REFERENCE_VOLCANO_LOCATION_REGION_SUCCESS,
} from './referenceDataReducer';

const bulkEditReferenceSaga = createApiSaga({
  apiFunction: apiPatch,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: REFERENCE_DATA_BULK_EDIT_REQUEST,
  successType: REFERENCE_DATA_BULK_EDIT_SUCCESS,
  failureType: REFERENCE_DATA_BULK_EDIT_FAILURE,
  successMessage: 'Saved',
});

const deleteReferenceSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/references/${action.id}`, ...action }),
  requestType: REFERENCE_DATA_DELETE_REFERENCE_REQUEST,
  successType: REFERENCE_DATA_DELETE_REFERENCE_SUCCESS,
  failureType: REFERENCE_DATA_DELETE_REFERENCE_FAILURE,
  successMessage: 'Deleted',
});

const getHavesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/reference/have-values', ...action }),
  requestType: REFERENCE_DATA_HAVE_REQUEST,
  successType: REFERENCE_DATA_HAVE_SUCCESS,
  failureType: REFERENCE_DATA_HAVE_FAILURE,
});

const getEqRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/regions', ...action }),
  requestType: REFERENCE_EARTHQUAKE_DATA_REGION_REQUEST,
  successType: REFERENCE_EARTHQUAKE_DATA_REGION_SUCCESS,
  failureType: REFERENCE_EARTHQUAKE_DATA_REGION_FAILURE,
});

const getVolRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: REFERENCE_VOLCANO_EVENT_DATA_REGION_REQUEST,
  successType: REFERENCE_VOLCANO_EVENT_DATA_REGION_SUCCESS,
  failureType: REFERENCE_VOLCANO_EVENT_DATA_REGION_FAILURE,
});

const getVolLocRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: REFERENCE_VOLCANO_LOCATION_REGION_REQUEST,
  successType: REFERENCE_VOLCANO_LOCATION_REGION_SUCCESS,
  failureType: REFERENCE_VOLCANO_LOCATION_REGION_FAILURE,
});

const getTsuValiditySaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_REQUEST,
  successType: REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS,
  failureType: REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_FAILURE,
});

const getTsuCauseSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_REQUEST,
  successType: REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_SUCCESS,
  failureType: REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_FAILURE,
});

const getTsuRunupMeasureTypesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST,
  successType: REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS,
  failureType: REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE,
});

const getTsuRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: REFERENCE_TSUNAMI_EVENT_DATA_REGION_REQUEST,
  successType: REFERENCE_TSUNAMI_EVENT_DATA_REGION_SUCCESS,
  failureType: REFERENCE_TSUNAMI_EVENT_DATA_REGION_FAILURE,
});


const getDepPublicationTypesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/publication-types', ...action }),
  requestType: REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_REQUEST,
  successType: REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_SUCCESS,
  failureType: REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_FAILURE,
});

const getDepGeologicAgesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/geologic-ages', ...action }),
  requestType: REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_REQUEST,
  successType: REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_SUCCESS,
  failureType: REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_FAILURE,
});

const getRunupValiditySaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: REFERENCE_RUNUP_DATA_VALIDITY_REQUEST,
  successType: REFERENCE_RUNUP_DATA_VALIDITY_SUCCESS,
  failureType: REFERENCE_RUNUP_DATA_VALIDITY_FAILURE,
});

const getRunupCausesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: REFERENCE_RUNUP_DATA_CAUSE_REQUEST,
  successType: REFERENCE_RUNUP_DATA_CAUSE_SUCCESS,
  failureType: REFERENCE_RUNUP_DATA_CAUSE_FAILURE,
});

const getRunupRunupMeasurementTypesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: REFERENCE_RUNUP_DATA_MEASURE_TYPE_REQUEST,
  successType: REFERENCE_RUNUP_DATA_MEASURE_TYPE_SUCCESS,
  failureType: REFERENCE_RUNUP_DATA_MEASURE_TYPE_FAILURE,
});

const getRunupRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: REFERENCE_RUNUP_DATA_REGION_REQUEST,
  successType: REFERENCE_RUNUP_DATA_REGION_SUCCESS,
  failureType: REFERENCE_RUNUP_DATA_REGION_FAILURE,
});


export const referenceDataSagas = [
  bulkEditReferenceSaga,
  deleteReferenceSaga,
  getHavesSaga,

  getEqRegionsSaga,

  getVolRegionsSaga,

  getVolLocRegionsSaga,

  getTsuValiditySaga,
  getTsuCauseSaga,
  getTsuRunupMeasureTypesSaga,
  getTsuRegionsSaga,

  getDepPublicationTypesSaga,
  getDepGeologicAgesSaga,

  getRunupValiditySaga,
  getRunupCausesSaga,
  getRunupRunupMeasurementTypesSaga,
  getRunupRegionsSaga,
];
